import React from 'react';
import './styles.css';

const icons = {
  home: {
    outline: (
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    ),
    filled: (
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" fill="currentColor" />
    )
  },
  explore: {
    outline: (
      <g>
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </g>
    ),
    filled: (
      <g>
        <circle cx="11" cy="11" r="8" fill="currentColor" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </g>
    )
  },
  notifications: {
    outline: (
      <g>
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </g>
    ),
    filled: (
      <g>
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" fill="currentColor" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </g>
    )
  },
  profile: {
    outline: (
      <g>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </g>
    ),
    filled: (
      <g>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" fill="currentColor" />
        <circle cx="12" cy="7" r="4" fill="currentColor" />
      </g>
    )
  },
  settings: (
    <g>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </g>
  ),
  sun: (
    <g>
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </g>
  ),
  moon: (
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  ),
  close: (
    <g>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </g>
  ),
  'message-circle': (
    <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z" />
  ),
  'message-square': (
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z" />
  ),
  'check-in': (
    <path d="M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
  ),
  'users': (
    <g>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </g>
  ),
  'share': (
    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
  ),
  'map-pin': (
    <g>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </g>
  ),
  calendar: (
    <g>
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </g>
  ),
  'more-horizontal': (
    <g>
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
      <circle cx="5" cy="12" r="1" />
    </g>
  ),
  'trash-2': (
    <g>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </g>
  ),
  'notification-bell': {
    outline: (
      <path 
        fillRule="evenodd"
        d="M11.996 2c-4.062 0-7.49 3.021-7.999 7.051L2.866 18H7.1c.463 2.282 2.481 4 4.9 4s4.437-1.718 4.9-4h4.236l-1.143-8.958C19.48 5.017 16.054 2 11.996 2zM9.171 18h5.658c-.412 1.165-1.523 2-2.829 2s-2.417-.835-2.829-2z"
      />
    ),
    filled: (
      <path 
        fill="currentColor"
        d="M11.996 2c-4.062 0-7.49 3.021-7.999 7.051L2.866 18H7.1c.463 2.282 2.481 4 4.9 4s4.437-1.718 4.9-4h4.236l-1.143-8.958C19.48 5.017 16.054 2 11.996 2zM9.171 18h5.658c-.412 1.165-1.523 2-2.829 2s-2.417-.835-2.829-2z"
      />
    )
  },
  search: (
    <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  ),
  'list': (
    <g>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </g>
  ),
  'map': (
    <g>
      <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
      <line x1="8" y1="2" x2="8" y2="18" />
      <line x1="16" y1="6" x2="16" y2="22" />
    </g>
  ),
  'chevron-down': (
    <polyline points="6 9 12 15 18 9" />
  ),
  'filter': (
    <g>
      <line x1="4" y1="21" x2="4" y2="14" />
      <line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" />
      <line x1="20" y1="12" x2="20" y2="3" />
      <line x1="1" y1="14" x2="7" y2="14" />
      <line x1="9" y1="8" x2="15" y2="8" />
      <line x1="17" y1="16" x2="23" y2="16" />
    </g>
  ),
  'bot-assistant': (
    <g>
      <rect x="3" y="11" width="18" height="10" rx="2" />
      <circle cx="12" cy="5" r="2" />
      <path d="M12 7v4" />
      <path d="M8 15h8" />
      <path d="M8 18h8" />
    </g>
  ),
  'arrow-left': (
    <g>
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </g>
  ),
  'chevron-right': (
    <polyline points="9 18 15 12 9 6" />
  ),
  'help-circle': (
    <g>
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </g>
  ),
  bell: {
    outline: (
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" />
    ),
    filled: (
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" fill="currentColor" />
    )
  },
  running: {
    outline: (
      <g>
        <path d="M13 4v6m-2 0l-3 3v5l3-2 3 2v-5l-3-3m-4 2l-3 3v5l3-2 3 2v-5m4-9a2 2 0 100-4 2 2 0 000 4z" />
      </g>
    ),
    filled: (
      <g>
        <path d="M13 4v6m-2 0l-3 3v5l3-2 3 2v-5l-3-3m-4 2l-3 3v5l3-2 3 2v-5m4-9a2 2 0 100-4 2 2 0 000 4z" fill="currentColor" />
      </g>
    )
  },
  bike: {
    outline: (
      <g>
        <circle cx="5.5" cy="17.5" r="3.5"/>
        <circle cx="18.5" cy="17.5" r="3.5"/>
        <path d="M15 6a1 1 0 100-2 1 1 0 000 2zm-3 11.5v-7l-3-3 4-3 2 3h2"/>
      </g>
    ),
    filled: (
      <g>
        <circle cx="5.5" cy="17.5" r="3.5" fill="currentColor"/>
        <circle cx="18.5" cy="17.5" r="3.5" fill="currentColor"/>
        <path d="M15 6a1 1 0 100-2 1 1 0 000 2zm-3 11.5v-7l-3-3 4-3 2 3h2" fill="currentColor"/>
      </g>
    )
  },
  bolt: {
    outline: (
      <path 
        d="M10 2L3 14h9l-1 8 7-12h-9l1-8z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ),
    filled: (
      <path 
        d="M10 2L3 14h9l-1 8 7-12h-9l1-8z"
        fill="currentColor"
      />
    )
  },
  'camera': {
    outline: (
      <g>
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
        <circle cx="12" cy="13" r="4" />
      </g>
    ),
    filled: (
      <g>
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" fill="currentColor" />
        <circle cx="12" cy="13" r="4" fill="currentColor" />
      </g>
    )
  },
  'directions': {
    outline: (
      <g>
        <path d="M22.43 10.59l-8.99-8.99a2.003 2.003 0 0 0-2.83 0l-8.99 8.99a2.003 2.003 0 0 0 0 2.83l8.99 8.99a2.003 2.003 0 0 0 2.83 0l8.99-8.99a2.003 2.003 0 0 0 0-2.83zM12 21.17L3.41 12.59 12 4.01l8.59 8.58L12 21.17z" />
        <path d="M12 7v5l3 3" />
      </g>
    ),
    filled: (
      <g>
        <path d="M12 2c-.53 0-1.04.21-1.41.59l-8.99 8.99a2.003 2.003 0 0 0 0 2.83l8.99 8.99a2.003 2.003 0 0 0 2.83 0l8.99-8.99a2.003 2.003 0 0 0 0-2.83l-8.99-8.99A1.98 1.98 0 0 0 12 2zm1 14h-2v-5h2v5zm0-7h-2V7h2v2z" fill="currentColor" />
      </g>
    )
  },
  'calendar-plus': {
    outline: (
      <g>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <line x1="12" y1="14" x2="12" y2="18" />
        <line x1="10" y1="16" x2="14" y2="16" />
      </g>
    ),
    filled: (
      <g>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" fill="currentColor" fillOpacity="0.15" />
        <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" />
        <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" />
        <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" />
        <line x1="12" y1="14" x2="12" y2="18" stroke="currentColor" />
        <line x1="10" y1="16" x2="14" y2="16" stroke="currentColor" />
      </g>
    )
  },
  'logout': (
    <g>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </g>
  ),
  'plus': (
    <g>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </g>
  ),
  'send': (
    <g>
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </g>
  ),
  'robot': {
    outline: (
      <g>
        <rect x="3" y="11" width="18" height="10" rx="2" />
        <circle cx="12" cy="5" r="2" />
        <path d="M12 7v4" />
        <circle cx="8" cy="16" r="1" />
        <circle cx="16" cy="16" r="1" />
      </g>
    ),
    filled: (
      <g>
        <rect x="3" y="11" width="18" height="10" rx="2" fill="currentColor" fillOpacity="0.15" />
        <circle cx="12" cy="5" r="2" />
        <path d="M12 7v4" />
        <circle cx="8" cy="16" r="1.5" fill="currentColor" />
        <circle cx="16" cy="16" r="1.5" fill="currentColor" />
      </g>
    )
  },
  'compass': {
    outline: (
      <g>
        <circle cx="12" cy="12" r="10" />
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
      </g>
    ),
    filled: (
      <g>
        <circle cx="12" cy="12" r="10" fillOpacity="0.1" fill="currentColor" />
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" fill="currentColor" />
      </g>
    )
  },
  'sunset': {
    outline: (
      <g>
        <path d="M17 18a5 5 0 0 0-10 0" />
        <line x1="12" y1="9" x2="12" y2="2" />
        <line x1="4.22" y1="10.22" x2="5.64" y2="11.64" />
        <line x1="1" y1="18" x2="3" y2="18" />
        <line x1="21" y1="18" x2="23" y2="18" />
        <line x1="18.36" y1="11.64" x2="19.78" y2="10.22" />
        <line x1="23" y1="22" x2="1" y2="22" />
        <polyline points="16 5 12 9 8 5" />
      </g>
    ),
    filled: (
      <g>
        <path d="M17 18a5 5 0 0 0-10 0" fill="currentColor" fillOpacity="0.2" />
        <line x1="12" y1="9" x2="12" y2="2" />
        <line x1="4.22" y1="10.22" x2="5.64" y2="11.64" />
        <line x1="1" y1="18" x2="3" y2="18" />
        <line x1="21" y1="18" x2="23" y2="18" />
        <line x1="18.36" y1="11.64" x2="19.78" y2="10.22" />
        <line x1="23" y1="22" x2="1" y2="22" />
        <polyline points="16 5 12 9 8 5" />
      </g>
    )
  },
  'tree': {
    outline: (
      <g>
        <path d="M12 22v-4" />
        <path d="M7 22h10" />
        <path d="M12 18l-4-8h8l-4 8" />
        <path d="M12 10l-3-6h6l-3 6" />
      </g>
    ),
    filled: (
      <g>
        <path d="M12 22v-4" />
        <path d="M7 22h10" />
        <path d="M12 18l-4-8h8l-4 8" fill="currentColor" fillOpacity="0.3" />
        <path d="M12 10l-3-6h6l-3 6" fill="currentColor" fillOpacity="0.5" />
      </g>
    )
  },
  'palette': {
    outline: (
      <g>
        <circle cx="13.5" cy="6.5" r="0.5" fill="currentColor" />
        <circle cx="17.5" cy="10.5" r="0.5" fill="currentColor" />
        <circle cx="8.5" cy="7.5" r="0.5" fill="currentColor" />
        <circle cx="6.5" cy="12.5" r="0.5" fill="currentColor" />
        <path d="M12 2a10 10 0 1 0 8.66 15A4 4 0 0 1 16 12a4 4 0 0 1 4-4 4 4 0 0 0-8-6" />
      </g>
    ),
    filled: (
      <g>
        <circle cx="13.5" cy="6.5" r="1.5" fill="currentColor" />
        <circle cx="17.5" cy="10.5" r="1.5" fill="currentColor" />
        <circle cx="8.5" cy="7.5" r="1.5" fill="currentColor" />
        <circle cx="6.5" cy="12.5" r="1.5" fill="currentColor" />
        <path d="M12 2a10 10 0 1 0 8.66 15A4 4 0 0 1 16 12a4 4 0 0 1 4-4 4 4 0 0 0-8-6" fillOpacity="0.1" fill="currentColor" />
      </g>
    )
  },
  'star': {
    outline: (
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    ),
    filled: (
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="currentColor" />
    )
  },
  'sparkles': {
    outline: (
      <g>
        <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z" />
        <path d="M5 19l1 3 1-3 3-1-3-1-1-3-1 3-3 1 3 1z" />
        <path d="M19 11l.5 1.5L21 13l-1.5.5-.5 1.5-.5-1.5L17 13l1.5-.5.5-1.5z" />
      </g>
    ),
    filled: (
      <g>
        <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z" fill="currentColor" />
        <path d="M5 19l1 3 1-3 3-1-3-1-1-3-1 3-3 1 3 1z" fill="currentColor" />
        <path d="M19 11l.5 1.5L21 13l-1.5.5-.5 1.5-.5-1.5L17 13l1.5-.5.5-1.5z" fill="currentColor" />
      </g>
    )
  },
  'zap': {
    outline: (
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    ),
    filled: (
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" fill="currentColor" />
    )
  },
  'clock': {
    outline: (
      <g>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </g>
    ),
    filled: (
      <g>
        <circle cx="12" cy="12" r="10" fillOpacity="0.1" fill="currentColor" />
        <polyline points="12 6 12 12 16 14" />
      </g>
    )
  },
  'login': (
    <g>
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
      <polyline points="10 17 15 12 10 7" />
      <line x1="15" y1="12" x2="3" y2="12" />
    </g>
  ),
};

export const Icon = ({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
  variant = 'filled',
  ...props
}) => {
  const icon = icons[name];
  if (!icon) return null;

  const iconContent = icon[variant] || icon.outline || icon;

  const isBell = name === 'notification-bell';
  
  return (
    <svg
      className={`icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      stroke={isBell ? 'none' : color}
      fill={isBell ? color : 'none'}
      strokeWidth={isBell ? '0' : '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {iconContent}
    </svg>
  );
}; 